import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';

/**
  * @author Ministerio de cultura
  * @createdate 2024-10-14
  * Interceptor que se encarga de redireccionar a la raiz cuando el token expire.
*/
@Injectable()
export class SessionInterceptor implements HttpInterceptor {

  constructor(
    private router: Router
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          localStorage.clear();
          this.router.navigate(['/']);
          return throwError(() => error);
        }
        if (error.status === 403) {
          this.router.navigate(['unauthorized']);
          return throwError(() => error);
        }
        return next.handle(request);
      })
    );
  }
}